import globalToast from "../components/common/globalToast";
import api from "../services/api";
import { stepNames } from "../utils/data_variables";

const service_path = "/production-steps.php";

export function getProductionSteps() {
    return api.get(service_path);
}

export function getProductionStepDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function mapProductionStepNames(steps = []) {
    const names = { ...stepNames };
    steps.forEach((step) => {
        names[step.id] = step.name;
    });
    return names;
}

export function createProductionStep(data, navigateBack) {
    api.post(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Etapa cadastrada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function updateProductionStep(data, navigateBack) {
    api.patch(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Etapa editada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function deleteProductionStep(id) {
    return api.delete(service_path, { data: { id } })
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Etapa desativada com sucesso!");
            } else {
                globalToast.error(body.message || "Houve um erro ao desativar essa etapa!");
            }
        })
        .catch((error) => {
            globalToast.error(error.response?.data?.message || "Houve um erro ao desativar essa etapa!");
            console.log(error);
        });
}
